import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import { ColumnHeaderCell, EditableCell, Cell, Column, Table } from "@blueprintjs/table";

import convertMinutesToString from '../../Components/convertMinutesToString';
import { ContextMenuTarget, Menu, MenuItem, Divider } from "@blueprintjs/core";

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");


export default class TableDummy extends Master {

    state = {
        mitarbeiter: {},
        currentMitarbieter: {},
        dateArray: {},
        daysArray: {},
        dienste: [],
        kmGesamt: 0,
        copyData: [],
        besondererDienst: {},
        zeiterfassung: {}
    }

    getBesondererDienst = (index, value) => {
        var b_array = Object.keys(this.state.besondererDienst)
        if(b_array[index] !== undefined) {
            if(value) {
                return this.state.besondererDienst[b_array[index]]
            }
            return b_array[index]
        }
        return false
    }

    pos = {
        summierung: () => {
            return this.props.daysArray.length - 1
        },
        ltKv: () => {
            return this.props.daysArray.length + 1
        },
        Ustd: () => {
            return this.props.daysArray.length + 2
        },
        Ustd50: () => {
            return this.props.daysArray.length + 3
        },
        Vormonat: () => {
            return this.props.daysArray.length + 4
        },
        besondererDienst: () => {
            return this.props.daysArray.length + 2
        },
        row1: () => {
            return this.props.daysArray.length + 6
        },
        row2: () => {
            return this.props.daysArray.length + 7
        }
    }

    get_EZ = (isRaw) => {
        var gesamt = 0
        this.state.dienste.forEach((item) => {
            var zeit_brutto_zeit = item.umlaufplan.brutto_zeit
            if(item.zeit_brutto_zeit) {
                zeit_brutto_zeit = item.zeit_brutto_zeit
            }
            if(zeit_brutto_zeit > 0) {
                gesamt += zeit_brutto_zeit
            }
        })
        if(isRaw) {
            return gesamt
        }
        return convertMinutesToString(gesamt)
    }

    get_Pause = (isRaw) => {
        var gesamt = 0
        this.state.dienste.forEach((item, k) => {
            if(item.zeit_pause !== undefined) {
                gesamt += parseFloat(item.zeit_pause)
            }
        })
        if(isRaw) {
            return gesamt
        }
        return convertMinutesToString(gesamt)
    }

    getMitarbeiter = (value) => {
        return _.get(this.state.currentMitarbeiter, value);
    }

    saveZeiterfassung = (key, value) => {
        var data = {
            mitarbeiter_id: this.props.currentMitarbeiter.id,
            jahr: this.props.jahr,
            monat: this.props.monat,
            ...this.props.currentMitarbeiter.zeiterfassung
        }
        data[key] = value
        this.props.doZeiterfassung(data)
    }

    getZeiterfassung = (key) => {
        if(this.state.zeiterfassung[key] !== undefined) {
            return this.state.zeiterfassung[key]
        }
        return "";
    }

    shouldComponentUpdate(nextProps, nextState) {
        var doReturn = false
        if(nextProps.mitarbeiter !== nextState.mitarbeiter) {
            doReturn = true
            this.state.mitarbeiter = nextProps.mitarbeiter
        }
        if(nextProps.currentMitarbeiter !== nextState.currentMitarbeiter
            || nextProps.zeiterfassung !== nextState.currentMitarbeiter.zeiterfassung)
        {
            doReturn = true
            this.state.currentMitarbeiter = nextProps.currentMitarbeiter
            this.state.zeiterfassung = nextProps.currentMitarbeiter.zeiterfassung
        }
        if(nextProps.zeiterfassung !== nextState.zeiterfassung) {
            doReturn = true
            this.state.zeiterfassung = nextProps.currentMitarbeiter.zeiterfassung
        }
        if(nextProps.dateArray !== nextState.dateArray) {
            doReturn = true
            this.state.dateArray = nextProps.dateArray
        }
        if(nextProps.daysArray !== nextState.daysArray) {
            doReturn = true
            this.state.daysArray = nextProps.daysArray
        }
        if(nextProps.dienst !== nextState.dienst) {
            var days = []
            var daysInt = []
            this.state.dateArray.forEach((date, k) => {
                date = moment(date).format("L")
                days[date] = k
                daysInt.push()
            })
            nextProps.dienst.forEach((dienst) => {
                var date = moment(dienst.datum).format("L")
                daysInt[days[date]] = dienst
            })
            this.state.dienste = daysInt
            doReturn = true
        }
        return doReturn
    }

    lastRow = (rowIndex) => {
        if(rowIndex > this.pos.summierung()) {
            return <Cell />
        }
    }

    globalStyle = (rowIndex, noBg, columnIndex) => {
        var info = this.state.dienste[rowIndex]

        var style = {
            borderColor: "black"
        }

        if(info !== undefined) {
            var style = {}
            if(info.umlaufplan.id) {
                style = {
                    background: "#fdcb6e"
                }
            }

            if(info.ist_feiertag) {
                style.color = "#0984e3"
                style.fontWeight = "bold"
            }

            if(info.besonderer_dienst.kuerzel) {
                if(info.besonderer_dienst.kuerzel.toLowerCase() === "ft") {
                    style = {
                        color: "#0984e3",
                        fontWeight: "bold"
                    }
                }
                if(
                    info.besonderer_dienst.kuerzel.toLowerCase() === "k" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "kdf" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "frz" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "frzdf" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "au" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "fudf" ||
                    info.besonderer_dienst.kuerzel.toLowerCase() === "audf"
                ) {
                    style = {
                        color: "#0984e3",
                        fontWeight: "bold"
                    }
                }
                if(info.besonderer_dienst.kuerzel.toLowerCase() === "u") {
                    style = {
                        color: "#ff7675",
                        fontWeight: "bold"
                    }
                }
            }
        }

        if(rowIndex === this.pos.summierung()) {
            style.borderBottom = "solid 2px black"
        }

        if(rowIndex-1 === this.pos.summierung()) {
            style.borderBottom = "solid 1px black"
        }

        if(noBg && style.background) {
            delete style.background
        }

        if (rowIndex === this.pos.row1() || rowIndex === this.pos.row2()) {
            if (columnIndex == 8 || columnIndex == 10) {
              style.background = "rgb(238, 238, 238)";
            }
            if(columnIndex == 11) {
                style.background = "rgb(9, 132, 227)";
                style.color = "white";
            }
            if (columnIndex == 12) {
              style.background = "rgb(0, 184, 148)";
              style.color = "white";
            }
            if (columnIndex == 15) {
              style.background = "rgb(238, 238, 238)";
            }
        }
        
        style.textAlign = "center";
        style.justifyContent = "center"

        return style
    }

	datum_cellRenderer = (rowIndex, columnIndex)  => {

        var posB = this.pos.besondererDienst()

        if (rowIndex == this.pos.row1() || rowIndex == this.pos.row2()) {
            var style = {
              border: "solid 1px",
              textAlign: "center",
              borderRight: "0",
            };
            if(rowIndex == this.pos.row1()) {
                style.borderBottom = "0";
                return <Cell style={style}>+</Cell>;
            }
            return <Cell style={style}>-</Cell>;
        }

        if(rowIndex >= this.pos.besondererDienst()) {
            if(!this.getBesondererDienst(rowIndex-posB)) {
                return <Cell></Cell>
            }
            return <Cell style={{border: "solid 1px", textAlign: "center", borderRight: "0"}}>{this.getBesondererDienst(rowIndex-posB)}</Cell>
        }

        if(rowIndex > this.pos.summierung()) {
            return <Cell style={{...this.globalStyle(rowIndex)}}></Cell>
        }
        var ext = {}
        var info = this.state.dienste[rowIndex]
        if(!info) {
            ext = {color: "#aaa"}
        }

        var value = moment(this.props.dateArray[rowIndex]).format("L")
        this.appendToCopyData(rowIndex, columnIndex, value)
        return <Cell style={{textAlign: "center", ...ext, ...this.globalStyle(rowIndex)}}>{value}</Cell>
	}

    tag_cellRenderer = (rowIndex, columnIndex)  => {

        if (rowIndex == this.pos.row1() || rowIndex == this.pos.row2()) {
          var style = {
            border: "solid 1px",
            textAlign: "center",
            borderRight: "0",
          };
          if (rowIndex == this.pos.row1()) {
            style.borderBottom = "0";
          }
          return <Cell style={style}></Cell>;
        }

        var posB = this.pos.besondererDienst()
        if(rowIndex >= this.pos.besondererDienst()) {
            if(!this.getBesondererDienst(rowIndex-posB)) {
                return <Cell></Cell>
            }
            return <Cell style={{border: "solid 1px", textAlign: "center", borderLeft: "0"}}>{this.getBesondererDienst(rowIndex-posB, true)}</Cell>
        }

        if(rowIndex > this.pos.summierung()) {
            return <Cell style={{...this.globalStyle(rowIndex)}}></Cell>
        }
        var ext = {}
        var info = this.state.dienste[rowIndex]
        if(!info) {
            ext = {color: "#aaa"}
        }
        this.appendToCopyData(rowIndex, columnIndex, this.props.daysArray[rowIndex])
        return <Cell style={{textAlign: "center", ...ext, ...this.globalStyle(rowIndex)}}>{this.props.daysArray[rowIndex]}</Cell>
    }

    paket_cellRenderer = (rowIndex, columnIndex) => {

        if (rowIndex == this.pos.row1() || rowIndex == this.pos.row2()) {
          var style = {
            border: "solid 1px",
            background: "rgb(255, 255, 8)",
            borderRight: "0",
            zIndex: 1,
            width: "385px",
          };
          if (rowIndex == this.pos.row1()) {
            style.borderBottom = "0";
          }
          // save custom text
          var key = (rowIndex == this.pos.row1() ? "plus" : "minus") + "_text";
          return (
            <EditableCell
              style={{ ...style, ...this.globalStyle(rowIndex) }}
              depr_loading={this.props.isLoading}
              value={this.getZeiterfassung(key)}
              onConfirm={(value) => {
                this.saveZeiterfassung(key, value);
              }}
            ></EditableCell>
          );
        }

        if(rowIndex > this.pos.summierung()) {
            return <Cell style={{...this.globalStyle(rowIndex)}}></Cell>
        }

        var info = this.state.dienste[rowIndex]
        var ext = {textAlign: "center", fontWeight: "bold"}

        if(info !== undefined && info.besonderer_dienst.id !== undefined
            && ((info.besonderer_dienst.kuerzel).toUpperCase() !== "X" && (info.besonderer_dienst.kuerzel).toUpperCase() !== "I")) {

            var value = (info.besonderer_dienst.kuerzel).toUpperCase()
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <EditableCell depr_loading={this.props.isLoading}
                style={{...ext, ...this.globalStyle(rowIndex)}}
                onConfirm={(value) => {
                    info["besonderer_dienst_change"] = value
                    this.confirm(info)
                }}
                value={value ? value : ""}
            />
            //return <Cell style={{...ext, ...this.globalStyle(rowIndex)}}>test {value}</Cell>
        }

        if(info !== undefined && info.ist_feiertag) {
            return <Cell style={{...ext, color: "#aaa", ...this.globalStyle(rowIndex)}}>FT</Cell>
        }

        if(info !== undefined && info.umlaufplan.id !== undefined) {
            return <Cell style={{...ext, color: "#aaa", ...this.globalStyle(rowIndex)}}></Cell>
        }
        
        return <Cell style={{...ext, color: "#aaa", ...this.globalStyle(rowIndex)}}>DF</Cell>
    }

    linien_cellRenderer = (rowIndex, columnIndex) => {
        var info = this.state.dienste[rowIndex]
        if(info !== undefined && info.umlaufplan.id !== undefined) {
            return <Cell style={{...this.globalStyle(rowIndex)}}>{info.umlaufplan.kuerzel.split(".").join("")}</Cell>
        }
        return <Cell style={{...this.globalStyle(rowIndex)}}></Cell>
    }

    eeeStyle = {textAlign: "center", justifyContent: "center", background: "#eee"}
    eeeStyleWhite = {textAlign: "center", justifyContent: "center"}

    beginn_cellRenderer = (rowIndex, columnIndex) => {

        var key = "zeit_pause"
        if(rowIndex-1 === this.pos.summierung()) {

            // 
            //return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}></Cell>
            var gesamt = 0
            this.state.dienste.forEach((item, k) => {
                if(item.zeit_beginn_raw !== undefined) {
                    gesamt += parseFloat(item.zeit_beginn_raw)
                }
            })

            return <Cell style={{...this.eeeStyle, fontWeight: "bold", ...this.globalStyle(rowIndex)}}>{convertMinutesToString(gesamt)}</Cell>
        }

        if(rowIndex > this.pos.summierung()) {
            return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}></Cell>
        }

        var info = this.state.dienste[rowIndex]

        var classes = ""
        if(info !== undefined && info.umlaufplan) {
            if(info.zeit_beginn_raw > 0 && info.umlaufplan.start_raw !== info.zeit_beginn_raw) {
                info["zeit_beginn_overwrite"] = true
            }
        }
        if(info !== undefined && info["zeit_beginn_overwrite"]) {
            classes = "triangle"
        }
        if(info === undefined || info.besonderer_dienst.kuerzel !== undefined) {
            return <Cell className={classes} style={{...this.globalStyle(rowIndex)}}></Cell>
        }

        if(info !== undefined && info.umlaufplan.id !== "") {
            this.appendToCopyData(rowIndex, columnIndex, info.zeit_beginn ? info.zeit_beginn : "")
            return <Cell className={classes} style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}>{info.zeit_beginn ? info.zeit_beginn : ""}</Cell>
        }
        return <Cell className={classes} style={{...this.globalStyle(rowIndex)}}></Cell>
    }

    ende_cellRenderer = (rowIndex, columnIndex) => {

        if(rowIndex-1 === this.pos.summierung()) {

            //
            //return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}></Cell>

            var gesamt = 0
            this.state.dienste.forEach((item, k) => {
                if(item.zeit_ende_raw !== undefined) {
                    gesamt += parseFloat(item.zeit_ende_raw)
                }
            })
            return <Cell style={{...this.eeeStyle, fontWeight: "bold", ...this.globalStyle(rowIndex)}}>{convertMinutesToString(gesamt)}</Cell>
        }

        if(rowIndex > this.pos.summierung()) {
            return this.zusammenfassung("ende", rowIndex, columnIndex, true)
        }

        var info = this.state.dienste[rowIndex]
        var classes = ""
        if(info !== undefined && info.umlaufplan) {
            if(info.zeit_ende_raw > 0 && info.umlaufplan.ende_raw !== info.zeit_ende_raw) {
                info["zeit_ende_overwrite"] = true
            }
        }
        if(info !== undefined && info["zeit_ende_overwrite"]) {
            classes = "triangle"
        }

        if(info !== undefined && info.umlaufplan.id !== "") {
            if (info.umlaufplan.ende_raw > 0) {
                if(info.umlaufplan.ende_raw > 1440) {
                    info.umlaufplan.ende_raw = info.umlaufplan.ende_raw - 1440
                }
                this.appendToCopyData(rowIndex, columnIndex, info.zeit_ende ? info.zeit_ende : info.umlaufplan.ende)
                return <Cell className={classes} style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}>{info.zeit_ende ? info.zeit_ende : info.umlaufplan.ende}</Cell>
            }
            
        }

        
        return <Cell className={classes} style={{...this.globalStyle(rowIndex)}}></Cell>

    }

    ez_cellRenderer = (rowIndex, columnIndex) => {
        if(rowIndex-1 === this.pos.summierung()) {
            var value = this.get_EZ()
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{textAlign: "center", fontWeight: "bold", ...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }
        var info = this.state.dienste[rowIndex]
        if(info !== undefined && info.ist_kalender != true && info.umlaufplan.id !== "" && info.umlaufplan.brutto_zeit) {
            var zeit_brutto_zeit = info.umlaufplan.brutto_zeit
            if(info.zeit_brutto_zeit) {
                zeit_brutto_zeit = info.zeit_brutto_zeit
            }
            var value = convertMinutesToString(zeit_brutto_zeit)
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{textAlign: "center", ...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }
        return this.zusammenfassung("az", rowIndex, columnIndex, true)
    }

    istAz_cellRenderer = (rowIndex, columnIndex) => {

        if(rowIndex-1 === this.pos.summierung()) {
            var gesamt = 0
            this.state.dienste.forEach((item, k) => {
                var eintritt = ""
                var austritt = ""
                
                if(this.props.currentMitarbeiter) {
                    if(this.props.currentMitarbeiter.eintritt) {
                        eintritt = parseInt(moment(this.props.currentMitarbeiter.eintritt).format("DD"))
                    }
                    if(this.props.currentMitarbeiter.austritt) {
                        austritt = parseInt(moment(this.props.currentMitarbeiter.austritt).format("DD"))
                    }
                }
                
                var currentDay = parseInt(moment(item.datum).format("DD"))

                if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt && eintritt > 1 && currentDay < eintritt) {
                    return
                }

                if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt && austritt < 31 && currentDay > austritt) {
                    return
                }

                var nettoZeit = item.zeit_ende_raw - item.zeit_beginn_raw
                var pause = item.umlaufplan.pause
                if(item.zeit_pause) {
                    nettoZeit -= item.zeit_pause
                } else {
                    nettoZeit -= pause ? pause : 0
                }

                if((nettoZeit === 0 || nettoZeit === undefined) && item.besonderer_dienst.stunden>0) {
                    nettoZeit = parseInt(item.besonderer_dienst.stunden * 60)
                }
                if(nettoZeit > 0) {
                    gesamt += nettoZeit
                }
                
            })
            var value = convertMinutesToString(gesamt)
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{textAlign: "center", fontWeight: "bold", ...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }

        var info = this.state.dienste[rowIndex]
        if(info !== undefined && info.besonderer_dienst.stunden) {
            var value = convertMinutesToString(info.besonderer_dienst.stunden*60)
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }

        if(info !== undefined && info.umlaufplan.netto_zeit) {
            var nettoZeit = info.zeit_ende_raw - info.zeit_beginn_raw
            var pause = info.umlaufplan.pause
            if(info.zeit_pause > 0) {
                nettoZeit -= info.zeit_pause
            } else {
                nettoZeit -= pause ? pause : 0
            }
            this.appendToCopyData(rowIndex, columnIndex, convertMinutesToString(nettoZeit))
            return <Cell style={{...this.globalStyle(rowIndex, true)}}>{convertMinutesToString(nettoZeit)}</Cell>
        }

        return <Cell style={{...this.globalStyle(rowIndex, true)}}></Cell>

    }

    getZeiterfassungColumnIndex = (columnIndex) => {
        if (columnIndex == 8) {
          return "az";
        }
        if (columnIndex == 9) {
          return "diff";
        }
        if (columnIndex == 10) {
          return "abgerechnet";
        }
        if (columnIndex == 11) {
          return "ft_entgelt";
        }
        if (columnIndex == 12) {
          return "nacht";
        }
        if (columnIndex == 15) {
          return "diaeten";
        }
        return false
    }

    stdColumn = (rowIndex, columnIndex) => {
        var style = {
          border: "solid 1px",
          borderRight:
            columnIndex == 12 || columnIndex == 15 ? "solid 1px" : "none",
        };
          if (rowIndex == this.pos.row1()) {
            style.borderBottom = "0";
          }

          var key = (rowIndex == this.pos.row1() ? "plus" : "minus") + "_";
          key += this.getZeiterfassungColumnIndex(columnIndex);

          var value = this.getZeiterfassung(key);
          if(columnIndex < 15) {
            if (value == 0) {
                value = "";
            } else {
                value = convertMinutesToString(value);
            }
          } else {
            if (value > 0) {
                value = parseFloat(value).toFixed(2).replace(".", ",");
            } else {
                value = "";
            }
          }

          return (
            <EditableCell
              style={{ ...style, ...this.globalStyle(rowIndex, undefined, columnIndex) }}
              depr_loading={this.props.isLoading}
              value={value}
              onConfirm={(value) => {
                if(columnIndex < 15) {
                    value = this.convertStringToIntHours(value);
                } else {
                    value = parseFloat(value.toString().replace(",", "."));
                }
                this.saveZeiterfassung(key, value);
              }}
            ></EditableCell>
          );
    }

    az_cellRenderer = (rowIndex, columnIndex) => {

        if (rowIndex == this.pos.row1() || rowIndex == this.pos.row2()) {
          return this.stdColumn(rowIndex, columnIndex)
        }

        if(rowIndex < this.props.daysArray.length) {
            if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt) {
                var day = moment(this.props.currentMitarbeiter.eintritt).format("DD")
                if(day>rowIndex+1) {
                    return <Cell style={{...this.globalStyle(rowIndex, true)}}></Cell>
                }
            }

            if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt) {
                var day = moment(this.props.currentMitarbeiter.austritt).format("DD")
                if(day<=rowIndex) {
                    return <Cell style={{...this.globalStyle(rowIndex, true)}}></Cell>
                }
            }
        }
        
        if(rowIndex-1 === this.pos.summierung()) {
            var gesamt = 0
            this.state.dienste.forEach((item, k) => {
                var eintritt = ""
                var austritt = ""
                
                if(this.props.currentMitarbeiter) {
                    if(this.props.currentMitarbeiter.eintritt) {
                        eintritt = parseInt(moment(this.props.currentMitarbeiter.eintritt).format("DD"))
                    }
                    if(this.props.currentMitarbeiter.austritt) {
                        austritt = parseInt(moment(this.props.currentMitarbeiter.austritt).format("DD"))
                    }
                }
                
                var currentDay = parseInt(moment(item.datum).format("DD"))

                if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt && eintritt > 1 && currentDay < eintritt) {
                    return
                }

                if(this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt && austritt < 31 && currentDay > austritt) {
                    return
                }

                var nettoZeit = item.zeit_netto_zeit
                if((nettoZeit === 0 || nettoZeit === undefined) && item.besonderer_dienst.stunden>0) {
                    nettoZeit = parseInt(item.besonderer_dienst.stunden * 60)
                }
                if(nettoZeit > 0) {
                    gesamt += nettoZeit
                }
                
            })

            // add az from zeiterfassung
            var plus_az = parseInt(this.getZeiterfassung("plus_az"));
            var minus_az = parseInt(this.getZeiterfassung("minus_az"));
            // gesamt += plus_az - minus_az;

            var value = convertMinutesToString(gesamt)
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{textAlign: "center", ...this.eeeStyle, fontWeight: "bold", ...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }
        var info = this.state.dienste[rowIndex]

        if(info !== undefined && info.besonderer_dienst.stunden) {
            var value = convertMinutesToString(info.besonderer_dienst.stunden*60)
            this.appendToCopyData(rowIndex, columnIndex, value)
            return <Cell style={{textAlign: "center", ...this.eeeStyle, ...this.globalStyle(rowIndex, true)}}>{value}</Cell>
        }

        var classes = ""
        if(info !== undefined && info["zeit_netto_zeit_overwrite"]) {
            classes = "triangle"
        }

        if(info !== undefined && info.umlaufplan.netto_zeit) {
            var nettoZeit = info.zeit_netto_zeit
            this.appendToCopyData(rowIndex, columnIndex, convertMinutesToString(nettoZeit))
            return <EditableCell depr_loading={this.props.isLoading}
                className={classes}
                style={{...this.eeeStyle, ...this.globalStyle(rowIndex, true)}}
                onConfirm={(value) => {
                    var azRaw = this.convertStringToIntHours(value.replace(":", "", -1))
                    var nettoZeit = azRaw
                    if(!parseFloat(azRaw)) {
                        if(info !== undefined && info.besonderer_dienst.stunden) {
                            azRaw = info.besonderer_dienst.stunden*60
                        }
                        if(info !== undefined && info.umlaufplan.netto_zeit) {
                            azRaw = info.zeit_netto_zeit
                        }
                    }
                    info.zeit_netto_zeit = convertMinutesToString(azRaw)
                    info.zeit_netto_zeit = parseFloat(azRaw)
                    info.zeit_netto_zeit_overwrite = parseFloat(nettoZeit) > 0 ? true : false
                    this.confirm(info)
                }}
                value={convertMinutesToString(nettoZeit)}
            /> 
        }

        return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex, true)}}></Cell>
    }

    pause_cellRenderer = (rowIndex, columnIndex) => {


        var key = "zeit_pause"
        if(rowIndex-1 === this.pos.summierung()) {
            var gesamt = this.get_Pause()
            return <Cell style={{...this.eeeStyle, fontWeight: "bold", ...this.globalStyle(rowIndex)}}>{gesamt}</Cell>
        }

        var info = this.state.dienste[rowIndex]

        var classes = ""
        if(info !== undefined && info[key+"_overwrite"]) {
            classes = "triangle"
        }

        if(info && info.umlaufplan) {
            this.appendToCopyData(rowIndex, columnIndex, info.zeit_pause)
            var pause = info.zeit_pause
            return <EditableCell depr_loading={this.props.isLoading}
                className={classes}
                style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}
                onConfirm={(value) => {
                    info.zeit_pause = parseInt(value)
                    info.zeit_pause_overwrite = true
                    this.confirm(info)
                }}
                value={pause === 0 || !pause ? "" : pause}
            />
        }
        return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex)}}></Cell>
    }

    convVal = (key, val) => {
        switch(key) {
            case "zeit_std_diaeten":
                val = parseInt(val)
            break
            case "zeit_diaeten":
                val = (parseFloat(val).toFixed(2)).replace(".", ",")
            break
            default:
                val = convertMinutesToString(val)
        }
        return val
    }

    edit_stunden_cellRenderer = (key, overwrite, canEdit) => (rowIndex, columnIndex) => {

        if ( (rowIndex == this.pos.row1() || rowIndex == this.pos.row2()) && columnIndex !== 14 && columnIndex < 16) {
          return this.stdColumn(rowIndex, columnIndex);
        }

        var extStyle = {}
        if(rowIndex-1 === this.pos.summierung() && key !== "zeit_t3") {
            var gesamt = 0
            this.state.dienste.forEach((item, k) => {
                if(item[key] !== undefined) {
                    gesamt += parseFloat(item[key])
                }
            })

            // hook for info from zeiterfassung
            var _key = this.getZeiterfassungColumnIndex(columnIndex);
            if(_key) {
                var plus_val = this.getZeiterfassung("plus_"+_key);
                var minus_val = this.getZeiterfassung("minus_"+_key);
                //gesamt += parseFloat(plus_val) - parseFloat(minus_val);
            }

            var ext = {
                fontWeight: "bold"
            }
            if(key === "zeit_nachtstd") {
                ext.background = "#00b894"
                ext.color = "white"
                ext.fontWeight = "normal"
            }
            if(key === "zeit_ft_entgeld") {
                ext.background = "#0984e3"
                ext.color = "white"
                ext.fontWeight = "normal"
            }

            return <Cell style={{...this.eeeStyle, ...ext, ...this.globalStyle(rowIndex)}}>{this.convVal(key, gesamt)}</Cell>
        }

        if(rowIndex > this.pos.summierung()) {
            return this.zusammenfassung(key, rowIndex, columnIndex)
        }

        if(key === "zeit_ausgl_stunden") {
            extStyle.background = "#ffffff"
        }

        var info = this.state.dienste[rowIndex]
        if(!info) {
            if(canEdit !== undefined && !canEdit) {
                return <Cell style={{...this.globalStyle(rowIndex), ...extStyle}}></Cell>
            }
            return <Cell style={{...this.eeeStyle, ...this.globalStyle(rowIndex), ...extStyle}}></Cell>
        }

        var val = info[key]

        if(key === "zeit_nachtstd") {
            extStyle.color = "#00b894"
            extStyle.fontWeight = "bold"
        }
        
        if(key === "zeit_ft_entgeld") {
            extStyle.color = "#0984e3"
            extStyle.fontWeight = "bold"
        }

        var classes = ""
        if(info !== undefined && info[key+"_overwrite"]) {
            classes = "triangle"
        }

        if((val === 0 || val === undefined)) {
            classes = ""
        }

        if(val && key !== "zeit_t3") {
            val = this.convVal(key, val)
        }

        if(canEdit !== undefined && !canEdit) {
            return <Cell style={{...extStyle, ...this.globalStyle(rowIndex, true)}}>{val ? val : ""}</Cell>
        }
        
        if(key === "zeit_t3") {
            extStyle.textAlign = "left"
            classes += " text-left"
        }


        return <EditableCell depr_loading={this.props.isLoading}
            className={classes}
            style={{...this.eeeStyle, ...this.globalStyle(rowIndex, true), ...extStyle}}
            onConfirm={(value) => {
                switch(key) {
                    case "zeit_std_diaeten":
                        info[key] = parseInt(value)
                    break
                    case "zeit_diaeten":
                        info[key] = parseFloat((""+value).replace(",", "."))
                    break
                    case "zeit_t3":
                        info[key] = value
                    break
                    default:
                        info[key] = this.convertStringToIntHours(value)
                }

                if(info.ist_kalender) {
                    info.mitarbeiter = this.state.currentMitarbeiter.id
                }

                if(overwrite) {
                    info[key+"_overwrite"] = parseInt(value) > 0 ? true : false
                }

                // HOOK: Kurzarbeit
                if(key === "zeit_abger_stunden") {
                    if(overwrite) {
                        info[key+"_overwrite"] = true
                    }
                }

                this.confirm(info)
            }}
            value={val ? val : ""}
        />

    }

    zusammenfassung = (key, rowIndex, columnIndex, hasBg) => {

        var text = ""
        var className = ""
        var ext = {}

        var isEdit = false

        if(key === "zeit_ausgl_stunden"
            && rowIndex >= this.pos.ltKv()
            && rowIndex <= this.pos.Vormonat()
        ) {

            ext = {
                fontWeight: "bold",
                textAlign: "center",
                background: "white",
            }
            className = "mergeCellUst"

            if(rowIndex === this.pos.ltKv()) {
                text = "lt. Kv"
                ext.color = "red"
            }

            if(rowIndex === this.pos.Ustd()) {
                text = "ÜSTD-GRUNDLOHN"
                ext.background = "#e4e6fd"
                ext.left = "555px"
            }

            if(rowIndex === this.pos.Ustd50()) {
                text = "ÜSTD-ZUSCHL. 50%"
                ext.background = "#fab8f4"
            }

            if(rowIndex === this.pos.Vormonat()) {
                var value = this.getMitarbeiter("zeiterfassung.vormonat_key")
                if(value === undefined || value === "") {
                    text = "INFO"
                } else {
                    text = value
                }
                ext.background = "rgb(255, 255, 8)"
                isEdit = "vormonat_key"
            }

            ext.border = "solid 1px black"

        }

        if(key === "zeit_abger_stunden"
            && rowIndex >= this.pos.ltKv()
            && rowIndex <= this.pos.Vormonat()
        ) {
            ext = {
                fontWeight: "bold",
                textAlign: "center",
                background: "white",
            }

            if(rowIndex === this.pos.ltKv()) {
                text = convertMinutesToString(parseInt(this.getMitarbeiter("zeiterfassung.kv")))
                ext.color = "red"
                isEdit = "kv"
            }

            if(rowIndex === this.pos.Ustd()) {
                text = convertMinutesToString(parseInt(this.getMitarbeiter("zeiterfassung.ustd")))
                ext.background = "#e4e6fd"
                ext.left = "555px"
            }

            if(rowIndex === this.pos.Ustd50()) {
                text = convertMinutesToString(parseInt(this.getMitarbeiter("zeiterfassung.ustd50")))
                ext.background = "#fab8f4"
            }

            if(rowIndex === this.pos.Vormonat()) {
                text = convertMinutesToString(parseInt(this.getMitarbeiter("zeiterfassung.vormonat_value")))
                ext.background = "rgb(255,255,8)"
                isEdit = "vormonat_value"
            }

            ext.border = "solid 1px black"
            ext.borderLeft = "0px"
        }
 
        if(key === "ende" && rowIndex >= this.pos.ltKv()) {
            if(rowIndex === this.pos.ltKv()) {
                text = "Std.:"
            }
            if(rowIndex === this.pos.Ustd()) {
                text = "Pause"
            }
            ext.textAlign = "right"
        }

        if(key === "az" && rowIndex >= this.pos.ltKv() && rowIndex <= this.pos.Ustd50()) {

            ext = {
                textAlign: "center",
                background: "white",
            }

            if(rowIndex === this.pos.ltKv()) {
                text = this.get_EZ()
                ext.background = "#eee"
            }

            if(rowIndex === this.pos.Ustd()) {
                text = this.get_Pause()
                
            }

            if(rowIndex === this.pos.Ustd50()) {
                text = convertMinutesToString(parseFloat(this.get_EZ(true) - this.get_Pause(true)))
            }

            ext.border = "solid 1px black"
            ext.borderTop = "none"

        }

        if(key === "zeit_std_diaeten" && rowIndex === this.pos.ltKv()) {
            text = "Diäten"
            ext.border = "solid 2px black"
            ext.borderRight = "0px"
            ext.borderTop = "1px"
            ext.fontWeight = "bold"
        }

        if(key === "zeit_diaeten" && rowIndex === this.pos.ltKv()) {
            isEdit = "diaeten"
            text = parseFloat(this.getMitarbeiter("zeiterfassung.diaeten")).toFixed(2).replace(".", ",")
            ext.border = "solid 2px black"
            ext.borderLeft = "0px"
            ext.borderTop = "1px"
            ext.fontWeight = "bold"
            ext.backgroundColor = "#fdcb6e"
        }

        if(key === "zeit_t3") {
            text = ""
            isEdit = false
        }

        ext.fontSize = "14px !important"
        if(isEdit) {
            return <EditableCell depr_loading={this.props.isLoading}
                depr_loading={this.props.isLoading}
                className={className}
                style={{...ext, ...this.globalStyle(rowIndex, hasBg)}}
                onConfirm={(value) => {

                    switch (isEdit) {
                        case "kv": case "vormonat_value":
                            this.saveZeiterfassung(isEdit, this.convertStringToIntHours(parseInt(value)))
                        break
                        case "vormonat_key":
                            this.saveZeiterfassung("vormonat_key", value)
                        break
                        case "diaeten":
                            this.saveZeiterfassung("diaeten", parseFloat((""+value).replace(",", ".")))
                        break
                    }

                }}
                value={text ? text : ""}
            />
        }

        return <Cell className={className} style={{...ext, ...this.globalStyle(rowIndex, hasBg)}}>{text}</Cell>

    }

    default_cellRenderer = (rowIndex) => {
        return <Cell style={{...this.globalStyle(rowIndex)}}></Cell>
    }

    handleCheckboxChange = dienst => ({target}) => {
        dienst.ok = target.checked
        this.props.saveDienst(dienst.id, dienst)
    }

    confirm = (dienst) => {
        this.props.saveDienst(dienst.id, dienst)
    }

    appendToCopyData = (rowIndex, columnIndex, val) => {
        if(!this.state.copyData[rowIndex]) {
            this.state.copyData[rowIndex] = []
        }
        if(!this.state.copyData[rowIndex][columnIndex]) {
            this.state.copyData[rowIndex][columnIndex] = ""
        }
        this.state.copyData[rowIndex][columnIndex] = val
    }

    setBesondererDienst = (besondererDienst, dienst) => {
        if(window.confirm("Dienst ändern auf " + besondererDienst.kuerzel + "?")) {
            dienst["besonderer_dienst_change"] = besondererDienst.kuerzel
            this.confirm(dienst)
        }
    }

    contextMenu = (val) => {

        var row = val.target.rows[0]
        var info = this.state.dienste[row]
            
        if(info === undefined) {
            return(
                <Menu>
                    <MenuItem text={"Kein Dienst"} />
                </Menu>
            )
        }

        var menuItems = []
        this.props.besondererDienst.forEach((dienst) => {
            if(dienst.kuerzel.toLowerCase() === "k" || dienst.kuerzel.toLowerCase() === "ft") {
                return
            }
            menuItems.push(<MenuItem onClick={() => this.setBesondererDienst(dienst, info)} icon="small-tick" text={<span><b>{dienst.kuerzel}</b> - {dienst.name}</span>} />)
        })
        //menuItems.push(<MenuItem icon="new-link" text={"Trennlinie"} />)

        return(
            <Menu>
                {menuItems}
            </Menu>
        )

    }

	render() {

        var {
            mitarbeiter, dateArray, daysArray, dienst
        } = this.props

        var days = []
        var daysInt = []
        dateArray.forEach((date, k) => {
            date = moment(date).format("L")
            days[date] = k
            daysInt.push()
        })

        this.state.kmGesamt = 0
        var besondererDienst = {}
        dienst.forEach((dienst) => {
            var date = moment(dienst.datum).format("L")
            daysInt[days[date]] = dienst
            if(dienst.zeit_km !== undefined) {
                this.state.kmGesamt += parseInt(dienst.zeit_km)
            }
            if(dienst.besonderer_dienst.kuerzel !== undefined && dienst.besonderer_dienst.zeiterfassung) {
                var bKey = dienst.besonderer_dienst.kuerzel.toUpperCase()
                if(dienst.besonderer_dienst.zu_kuerzel) {
                    bKey = dienst.besonderer_dienst.zu_kuerzel.toUpperCase()
                } 
                if(besondererDienst[bKey] === undefined) {
                    besondererDienst[bKey] = 0
                }
                besondererDienst[bKey] += 1
            }
        })

        this.state.besondererDienst = besondererDienst
        this.state.dienste = daysInt

        var columnHeader = (columnIndex) => {

            var name = ""
            switch(columnIndex) {
                case 0:
                    name = "Datum"
                    break;
                case 1:
                    name = "Tag"
                    break;
                case 2:
                    name = "Paket"
                    break;
                case 3:
                    name = "Beginn"
                    break;
                case 4:
                    name = "Ende"
                    break;
                case 5:
                    name = "EZ"
                    break;
                case 6:
                    name = "Pause"
                    break;
                case 7:
                    name = "IST AZ"
                    break;
                case 8:
                    name = "AZ"
                    break;
                case 10:
                    name = "Abgerechn. H"
                    break;
                case 11:
                    name = "FT Entgelt"
                    break;
                case 12:
                    name = "Nacht H"
                    break;
                case 13:
                    name = "Linien Nr."
                    break;
                case 14:
                    name = "Std. Diäten"
                    break;
                case 15:
                    name = "Diäten"
                    break;
                case 16:
                    name = "Info"
                    break;
            }

            var nameRenderer = () => (
                <div style={{textAlign: "center"}}><small>{name}</small></div>
            )
            return <ColumnHeaderCell 
                enableColumnReordering={true}
                style={{textAlign: "center", justifyContent: "center", fontSize: 10}}
                name={"ok"}
                nameRenderer={nameRenderer}
            />
        }

        var bDienst = Object.keys(besondererDienst).length
        if(bDienst > 2) {
            bDienst = bDienst - 2
        } else {
            bDienst = 0
        }

		return (
			<Table
                getCellClipboardData={this.getCellClipboardData}
                defaultColumnWidth={200}
                bodyContextMenuRenderer={this.contextMenu}
                columnWidths={[
                    100,    // datum
                    50,     // tag
                    60,    // paket

                    65,     // beginn
                    65,     // ende

                    65,     // EZ
                    65,     // pause
                    65,     // ist az
                    65,     // az

                    65,     // Ausgleichs H
                    95,     // Abgerechn. H
                    75,     // FT Entgelt
                    75,     // Nacht H
                    75,     // Linien

                    75,     // Std. Diäten
                    75,      // Diäten
                    200      // Text
                ]}
                numRows={daysArray.length + 1 + 4 + bDienst + 4}
                enableFocusedCell={true}
                renderMode={"none"}
 			>   
                <Column columnHeaderCellRenderer={columnHeader} name="Datum" cellRenderer={this.datum_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="Tag" cellRenderer={this.tag_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="Paket" cellRenderer={this.paket_cellRenderer} />

                <Column columnHeaderCellRenderer={columnHeader} name="Beginn" cellRenderer={this.beginn_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="Ende" cellRenderer={this.ende_cellRenderer} />

                <Column columnHeaderCellRenderer={columnHeader} name="EZ" cellRenderer={this.ez_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="Pause (=>90)" cellRenderer={this.pause_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="ist AZ" cellRenderer={this.istAz_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="AZ" cellRenderer={this.az_cellRenderer} />

                <Column columnHeaderCellRenderer={columnHeader} name="Ausgleichs H" cellRenderer={this.edit_stunden_cellRenderer("zeit_ausgl_stunden", true)} />
                <Column columnHeaderCellRenderer={columnHeader} name="Abgerechn. H" cellRenderer={this.edit_stunden_cellRenderer("zeit_abger_stunden", true)} />

                <Column columnHeaderCellRenderer={columnHeader} name="FT Entgelt" cellRenderer={this.edit_stunden_cellRenderer("zeit_ft_entgeld", true, true)} />
                <Column columnHeaderCellRenderer={columnHeader} name="Nacht H" cellRenderer={this.edit_stunden_cellRenderer("zeit_nachtstd", true, false)} />
                
                <Column columnHeaderCellRenderer={columnHeader} name="Linien Nr." cellRenderer={this.linien_cellRenderer} />
                <Column columnHeaderCellRenderer={columnHeader} name="Std. Diäten" cellRenderer={this.edit_stunden_cellRenderer("zeit_std_diaeten", false, true)} />
				<Column columnHeaderCellRenderer={columnHeader} name="Diäten" cellRenderer={this.edit_stunden_cellRenderer("zeit_diaeten", true, true)} />
                <Column columnHeaderCellRenderer={columnHeader} name="Info" cellRenderer={this.edit_stunden_cellRenderer("zeit_t3", false, true)} />

			</Table>
		)
	}
}

// KZ = Kennzeichen (Matchcode)
// KM =  (vierstellig)


// WEBPACK FOOTER //
// ./src/Routes/Zeiterfassung/stunden.js